var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e5cd1469bed0332eacb84215273d0d34f7d5f367"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["widget@swipelux-mh"]={id:"e5cd1469bed0332eacb84215273d0d34f7d5f367"};
      